import { render, staticRenderFns } from "./ontick-form-dropdown.component.vue?vue&type=template&id=ca1e0610&scoped=true"
import script from "./ontick-form-dropdown.component.vue?vue&type=script&lang=js"
export * from "./ontick-form-dropdown.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-form-dropdown.component.vue?vue&type=style&index=0&id=ca1e0610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1e0610",
  null
  
)

export default component.exports